import {
  WSCard,
  WSFlexBox,
  WSInfoBox,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { useHistory } from "react-router-dom";
import { useQueryInternalAccount } from "../../../query/banking/queries/useQueryInternalAccount";
import { useQueryInternalAccountBalance } from "../../../query/banking/queries/useQueryInternalAccountBalance";

type Props = {
  internalAccountId: string;
};

export const InternalAccountBalance: React.FC<Props> = props => {
  const history = useHistory();
  const queryInternalAccount = useQueryInternalAccount(props.internalAccountId);
  const queryInternalAccountBalance = useQueryInternalAccountBalance(
    props.internalAccountId
  );

  const availableBalance = queryInternalAccountBalance.data?.available || 0;
  const currentBalance = queryInternalAccountBalance.data?.balance || 0;
  const pendingAmounts = queryInternalAccountBalance.data?.hold || 0;

  return (
    <WSCard
      shimmer={queryInternalAccountBalance.isInitialLoading}
      fullHeight
      header={{
        label: {
          text: "Available balance"
        }
      }}
      divider
      actions={
        queryInternalAccount.data?.type === "ApPayouts"
          ? {
              alignment: "fill",
              buttons: [
                {
                  kind: "Secondary",
                  label: "Transfer",
                  onClick: () => {
                    history.push({
                      pathname: "/member/transfer",
                      search: "?balance=platform&type=withdrawal"
                    });
                  }
                }
              ]
            }
          : undefined
      }
    >
      <WSText.Heading1
        weight="book"
        color={availableBalance > 0 ? "gray600" : "gray200"}
        mb="XL"
      >
        {formatMoney(
          availableBalance,
          queryInternalAccount.data?.currency || "USD"
        )}
      </WSText.Heading1>

      <WSFlexBox.CenterY justify="space-between" mb="M">
        <WSText.ParagraphSm color="gray500">Current balance</WSText.ParagraphSm>
        <WSText.ParagraphSm color="gray600">
          {formatMoney(
            currentBalance,
            queryInternalAccount.data?.currency || "USD"
          )}
        </WSText.ParagraphSm>
      </WSFlexBox.CenterY>

      <WSFlexBox.CenterY justify="space-between">
        <WSText.ParagraphSm color="gray500">Pending amounts</WSText.ParagraphSm>
        <WSText.ParagraphSm color="gray500">
          {formatMoney(
            pendingAmounts,
            queryInternalAccount.data?.currency || "USD"
          )}
        </WSText.ParagraphSm>
      </WSFlexBox.CenterY>

      {queryInternalAccount.data?.type === "ApPayouts" && (
        <WSInfoBox mt="XL" title="Transferring your available balance">
          We recommend transferring the available balance to your external bank
          account regularly (within 90 days the balance became available). The
          Platform Balance is for temporarily holding balances from paid
          invoices to be transferred out and cannot accept deposits from
          external bank accounts.
        </WSInfoBox>
      )}
    </WSCard>
  );
};
